// MyPage.js
import React, { useState, useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  Container,
  ModalOverlay,
  ModalContent,
  Button,
} from './StyledComponents';
import PersonalInfoForm from './PersonalInfoForm';
import BusinessInfoForm from './BusinessInfoForm';
import BusinessImage from './BusinessImage';


const MyPage = () => {
  const { isLoggedIn, logout } = useAuth();
  const [isEditing, setIsEditing] = useState(false);
  const navigate = useNavigate();

  // 사용자 정보 상태
  const [userInfo, setUserInfo] = useState(() => {});
  const [bizRegCert, setBizRegCert] = useState(() => {});

  // 사업자 정보 상태
  const [companyName, setCompanyName] = useState('');
  const [businessNumber, setBusinessNumber] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  const [representativeName, setRepresentativeName] = useState('');
  const [industryType, setIndustryType] = useState('');
  const [businessCategory, setBusinessCategory] = useState('');
  const [address, setAddress] = useState('');
  const [bank, setBank] = useState('');
  
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [apiResponse, setApiResponse] = useState(null);
  

  useEffect(() => {
    if (bizRegCert) {
      // bizRegCert가 변경된 후에 실행할 로직
      //console.log('bizRegCert가 업데이트되었습니다:', bizRegCert);
    }
  }, [bizRegCert]);
  // 사용자 정보 가져오기
  useEffect(() => {
    const getUserInfo = async () => {
      try {
        const response = await fetch('/request/getUserInfo', {
          method: 'GET',
          credentials: 'include',
        });
        if (response.ok) {
          const data = await response.json();
          const dateOfBirth = data.date_of_birth || '';
          const [birth_y = '', birth_m = '', birth_d = ''] = dateOfBirth.split('-');
          setUserInfo({
            ...data,
            birth_y,
            birth_m,
            birth_d,
          });
        } else {
          throw new Error('Failed to fetch user info');
        }
      } catch (error) {
        navigate('/login');
      }
    };

    getUserInfo();
  }, []);

  // 사업자 정보 가져오기
  useEffect(() => {
    const fetchBusinessInfo = async () => {
      try {
        const response = await fetch('/request/getBusinessInfo', {
          method: 'GET',
          credentials: 'include',
        });
        if (response.ok) {
          const data = await response.json();
          setCompanyName(data.company_name);
          setBusinessNumber(data.business_number);
          setRepresentativeName(data.representative_name);
          setIndustryType(data.industry_type);
          setBusinessCategory(data.business_category);
          setAddress(data.address);
          setAccountNumber(data.account_number);
          setBank(data.bank);
          setBizRegCert(data.biz_reg_cert || null);
          setUserInfo((prev) => ({ ...prev, bank: data.bank }));
        } else {
          throw new Error('Failed to fetch business info');
        }
      } catch (error) {
        console.error('Error fetching business info:', error);
        navigate('/login');
      }
    };
    fetchBusinessInfo();
  }, []);

  


  const handleEdit = () => {
    setIsEditing(true);
    
    // 생년월일이 이미 userInfo에 설정되어 있으면 그 값을 유지하고, 없는 경우에만 user에서 값을 가져와서 설정
    const dateOfBirth = userInfo.date_of_birth || user.date_of_birth || ''; 
    const [birth_y = userInfo.birth_y || '', birth_m = userInfo.birth_m || '', birth_d = userInfo.birth_d || ''] = dateOfBirth.split('-');
  
    setUserInfo((prevUserInfo) => ({
      ...prevUserInfo,  // 기존 값은 그대로 유지
      birth_y: prevUserInfo.birth_y || birth_y,  // 만약 기존에 설정된 값이 없으면 새로운 값으로 설정
      birth_m: prevUserInfo.birth_m || birth_m,
      birth_d: prevUserInfo.birth_d || birth_d,
    }));
  };

  const handleDelete = async () => {
    if (window.confirm("정말로 계정을 삭제하시겠습니까?")) {
      try {
        const response = await fetch(`/request/DeleteProfile/${userInfo.id}`, {
          method: 'DELETE',
        });

        if (!response.ok) throw new Error(await response.text());
        alert("계정이 성공적으로 삭제되었습니다.");
        logout();
        navigate('/');
      } catch (error) {
        console.error("계정 삭제 실패: ", error);
        alert("계정 삭제에 실패하였습니다.");
      }
    }
  };

  const handleSave = async () => {
    setIsEditing(false);
    try {
      // alert(JSON.stringify(userInfo));
      const response = await fetch('/request/UpdateProfile', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          user_id: userInfo.user_id,
          user_name: userInfo.user_name,
          user_pwd: userInfo.password,
          gender: userInfo.gender,
          birth_y: userInfo.birth_y,
          birth_m: userInfo.birth_m,
          birth_d: userInfo.birth_d,
          email: userInfo.email_address,
          phone: userInfo.user_mobile,
          alias: userInfo.alias || '',
        }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
      }
      const data = await response.json();
      setApiResponse(data);
      alert('프로필 수정이 성공적으로 완료되었습니다.');
    } catch (error) {
      console.error("프로필 수정 실패: ", error);
      alert("프로필 수정 실패: " + error.message);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserInfo({ ...userInfo, [name]: value });
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleUpdate = async (event) => {
    try {
      const response = await fetch('/request/updateBusinessInfo', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          company_name: companyName,
          business_number: businessNumber,
          representative_name: representativeName,
          industry_type: industryType,
          business_category: businessCategory,
          address: address,
          account_number: accountNumber,
          bank: userInfo.bank,
        }),
        credentials: 'include',
      });

      if (!response.ok) throw new Error('Failed to update business info');
      alert('정보가 업데이트되었습니다.');
      navigate('/Settings/MyPage');
    } catch (error) {
      console.error('Error updating business info:', error);
    }
  };

  if (!isLoggedIn) {
    return <Navigate to="/Login" />;
  }

  return (
    <Container>
      
      {userInfo && (
        <PersonalInfoForm
          userInfo={userInfo}
          isEditing={isEditing}
          handleEdit={handleEdit}
          handleSave={handleSave}
          handleChange={handleChange}
          handleDelete={handleDelete}
          setIsEditing={setIsEditing}
        />
      )}
      {userInfo && (
        <BusinessInfoForm
          companyName={companyName}
          setCompanyName={setCompanyName}
          businessNumber={businessNumber}
          setBusinessNumber={setBusinessNumber}
          representativeName={representativeName}
          setRepresentativeName={setRepresentativeName}
          industryType={industryType}
          setIndustryType={setIndustryType}
          businessCategory={businessCategory}
          setBusinessCategory={setBusinessCategory}
          address={address}
          bank={bank}
          setAddress={setAddress}
          accountNumber={accountNumber}
          setAccountNumber={setAccountNumber}
          userInfo={userInfo}
          handleChange={handleChange}
          handleUpdate={handleUpdate}
          handleOpenModal={handleOpenModal}
         
        />
      )}
       {userInfo && (
      <BusinessImage
       bizRegCert={bizRegCert}
       setBizRegCert={setBizRegCert}
      />)}
      {/* 모달 컴포넌트 */}
    </Container>
  );
};

export default MyPage;